const combineOffersWithFavourites = ({ offers = [], favourites = [] }) => offers.map(offer => ({
  ...offer,
  isFavourite: favourites
    .filter(({ offerId }) => offerId === offer.offerId)
    .map(({ isSaved }) => isSaved)
    .pop() || false
}));

export default combineOffersWithFavourites;
